import classnames from 'classnames';
import * as React from 'react';
import '../styles/List.scss';

type ListProps = React.PropsWithChildren<{
    className?: string;
    isUnpadded?: boolean;
}>;

export function List({ children, className, isUnpadded }: ListProps) {
    return <div className={classnames(className, 'palette-list', { 'palette-list--unpadded': isUnpadded })}>{children}</div>;
}
